//region :: Imports ::
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {MNullable} from '../../Utils';

//endregion

let appInsights: MNullable<ApplicationInsights> = null;
let appInsightsPlugin: MNullable<ReactPlugin> = null;

/** */
export const initializeAppInsights = (connectionString: string) => {

    appInsightsPlugin = new ReactPlugin();
    appInsights = new ApplicationInsights({
        config: {
            connectionString: connectionString,
            extensions: [appInsightsPlugin]
        }
    });

    appInsights.loadAppInsights();

};

/** */
export const getAppInsights = () => appInsights;

/** */
export const getAppInsightsPlugin = () => appInsightsPlugin;
